import { InvoicesService_invoicesServiceGetGet } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesService_invoicesServiceGetGet'

export const useFetchInvoiceOverviewCollection =
  InvoicesService_invoicesServiceGetGet.useSuspenseQuery
